<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <div class="tab-div">
    <v-subheader class="subtitle-1 whitesmoke font-weight-medium grayBold--text">
      {{ $t("clientSideviewClientInfo") }}
    </v-subheader>
    <v-list two-line class="whitesmoke tab" min-width="200px">
      <v-list-item v-if="client.info.email">
        <v-list-item-content>
          <v-list-item-title class="overline grayBold--text">
            {{ $t("email") }}
          </v-list-item-title>
          <v-list-item-subtitle class="pt-1 grayBold--text"> {{client.info.email}} </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-4 mt-2"/>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="overline grayBold--text">
            {{ $t("clientSideviewContactsUppercase") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="item in client.contacts" :key="item.id">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-phone
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{item.phone}}</v-list-item-title>
          <v-list-item-subtitle>{{$t(item.contact_type)}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon v-if="item.is_primary">
          <v-icon>mdi-star</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </div>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'

@Component
export default class ClientsSideviewGeneralTab extends Vue {
 @Prop() client: Record<string, any>;


  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(70vh - 250px) !important;
  overflow-y: auto;
}

// .tab-div { 
//     // width:100%;
// }
</style>
